class NavBarAccountButtonsComponent extends HTMLElement {
  constructor() {
    super();
    document.addEventListener('customer-logged-in', () => {
      document.getElementById('visitor-nav-items').classList.add('d-none')
      document.getElementById('customer-nav-items').classList.remove('d-none')
    }, true)
    document.addEventListener('customer-logged-out', () => {
      document.getElementById('visitor-nav-items').classList.remove('d-none')
      document.getElementById('customer-nav-items').classList.add('d-none')
    }, true)

  }

  connectedCallback() {
    this.innerHTML = String.raw`
      <ul class="nav ms-auto mb-2 mb-lg-0 align-middle" id="visitor-nav-items">
        <li class="nav-item"><button type="button" class="btn btn-primary navbar-btn hidden-print" data-bs-toggle="modal"
            data-bs-target="#modal-sign-up-form" id="navbar-create-account-button">Create an Account</button>
        </li>
        <li class="nav-item" style="margin-left:4px;"><button type="button" class="btn btn-default navbar-btn hidden-print" data-bs-toggle="modal"
            data-bs-target="#modal-login-form" id="login-button"><i class="fa fa-sign-in fa-fw"></i>
            Login</button>
        </li>
      </ul>
      
      <ul class="nav ms-auto mb-2 mb-lg-0 align-middle d-none" id="customer-nav-items">
        <li class="nav-item dropdown">
          <a class="nav-link" href="#" id="customLoggedInDropdown" role="button" data-bs-toggle="dropdown"
            aria-expanded="false">
            Signed in as <span id="signed-in-as">Pro Customer</span>
          </a>
          <ul class="dropdown-menu" aria-labelledby="customLoggedInDropdown">
          <li><a class="dropdown-item" href="beam-designer.html">New Beam Design</a></li>
            <li><a class="dropdown-item" href="account.html">My Account</a></li>
            <li><hr class="dropdown-divider"></li>
            <li><a class="dropdown-item" href="#" data-bs-toggle="modal" data-bs-target="#modal-logout-form">Logout</a></li>
          </ul>
        </li>
      </ul>
      `
  }
}

customElements.define('nav-bar-account-buttons-component', NavBarAccountButtonsComponent);